import base from '../dr-base'
import drSignaturePad from './dr-signature-pad.vue'

const schema = {
  ...base,
  $Type: 'dr-signature-pad',
  name: 'Signature Pad',
  group: 'Input widgets',
  icon: 'pen-alt',
  properties: {
    ...base.properties,
    Color: {
      name: 'vuetifyWidgets.dr-signature-pad.color',
      type: 'string',
      component: 'dr-color-picker'
    },
    Value: {
      name: 'vuetifyWidgets.dr-signature-pad.value',
      type: 'string',
      component: 'dr-value-editor'
    },
    OnClickAction: {
      name: 'vuetifyWidgets.dr-signature-pad.onClickAction',
      type: 'string'
    }
  }
}

export default {
  schema,
  component: drSignaturePad,
  propEditors: [
    {
      name: 'dr-color-picker'
    }
  ]
}
